var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('PMain',{attrs:{"dataKey":_vm.key},model:{value:(_vm.themeData),callback:function ($$v) {_vm.themeData=$$v},expression:"themeData"}},[_c('v-row',[_c('v-col',[_vm._v(" Clearing All ")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }